const avatarSize = 32;
const previewSize = 64;

export { avatarSize, previewSize };
